export const workoutsConstants = {
    WORKOUTS_REQUEST: "WORKOUTS_REQUEST",
    WORKOUTS_SUCCESS: "WORKOUTS_SUCCESS",
    WORKOUTS_FAILURE: "WORKOUTS_FAILURE",
    
    WORKOUTS_ALL_REQUEST: "WORKOUTS_ALL_REQUEST",
    WORKOUTS_ALL_SUCCESS: "WORKOUT_ALL_SUCCESS",
    WORKOUTS_ALL_FAILURE: "WORKOUTS_ALL_FAILURE",
};